module.exports = __webpack_public_path__ + "files/67f2753d85f24b5af6f0d8ad1ae02179.png";